module.exports = __webpack_public_path__ + "static/media/contact.65ad8b08.jpg";